var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lock",
    d: "M4.75 4.75C4.75 2.95 6.2 1.5 8 1.5C9.79 1.5 11.25 2.95 11.25 4.75L11.25 6L4.75 6L4.75 4.75ZM3.25 6.07L3.25 4.75C3.25 2.12 5.37 0 8 0C10.62 0 12.75 2.12 12.75 4.75L12.75 6.07C14.6 6.42 16 8.04 16 10L16 16C16 18.2 14.2 20 12 20L4 20C1.79 20 0 18.2 0 16L0 10C0 8.04 1.39 6.42 3.25 6.07ZM8 11.25C8.41 11.25 8.75 11.58 8.75 12L8.75 14C8.75 14.41 8.41 14.75 8 14.75C7.58 14.75 7.25 14.41 7.25 14L7.25 12C7.25 11.58 7.58 11.25 8 11.25Z",
    fill: "#0478FE",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1d24799fc61ad3b633023dd1aa70b328.svg";
export { ForwardRef as ReactComponent };